/*
 * Copyright (C) 2021 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import formatMessage from '../../format-message';
import '../tinymce/sl';
const locale = {
  "access_the_pretty_html_editor_37168efe": {
    "message": "Dostop do urejevalnika Pretty HTML Editor"
  },
  "accessibility_checker_b3af1f6c": {
    "message": "Orodje za preverjanje dostopnosti"
  },
  "action_to_take_b626a99a": {
    "message": "Dejanje, ki ga je treba izvesti:"
  },
  "add_8523c19b": {
    "message": "Dodaj"
  },
  "add_a_caption_2a915239": {
    "message": "Dodaj spremno besedilo"
  },
  "add_alt_text_for_the_image_48cd88aa": {
    "message": "Dodaj nadomestno besedilo za sliko"
  },
  "add_another_f4e50d57": {
    "message": "Dodaj dodatno"
  },
  "add_cc_subtitles_55f0394e": {
    "message": "Dodaj Kp/podnaslov"
  },
  "add_image_60b2de07": {
    "message": "Dodaj sliko"
  },
  "add_one_9e34a6f8": {
    "message": "Dodajte eno."
  },
  "additional_considerations_f3801683": {
    "message": "Dodatni razmisleki"
  },
  "address_applied_64269b0b": {
    "message": "Naslov uporabljen"
  },
  "address_removed_fcb496e0": {
    "message": "Naslov odstranjen"
  },
  "adjacent_links_with_the_same_url_should_be_a_singl_7a1f7f6c": {
    "message": "Sosednje povezave z istim naslovom URL morajo biti ena sama povezava."
  },
  "aleph_f4ffd155": {
    "message": "Alef"
  },
  "align_11050992": {
    "message": "Poravnaj"
  },
  "alignment_and_lists_5cebcb69": {
    "message": "Poravnava in seznami"
  },
  "all_4321c3a1": {
    "message": "Vse"
  },
  "all_apps_a50dea49": {
    "message": "Vse aplikacije"
  },
  "allow_media_download_16dcf2bd": {
    "message": "Dovoli prenos medijev"
  },
  "allow_transcript_download_3fa239f0": {
    "message": "Dovoli prenos prepisa"
  },
  "alpha_15d59033": {
    "message": "Alfa"
  },
  "alphabetical_55b5b4e0": {
    "message": "Abecedno"
  },
  "alt_attribute_text_should_not_contain_more_than_12_e21d4040": {
    "message": "Nadomestno besedilo lastnosti ne sme vsebovati več kot 120 znakov."
  },
  "alt_text_611fb322": {
    "message": "Nadomestno besedilo"
  },
  "amalg_coproduct_c589fb12": {
    "message": "Amalg (koprodukt)"
  },
  "an_error_occured_reading_the_file_ff48558b": {
    "message": "Pri branju datoteke je prišlo do napake"
  },
  "an_error_occurred_making_a_network_request_d1bda348": {
    "message": "Med podajanjem omrežne zahteve je prišlo do napake."
  },
  "an_error_occurred_uploading_your_media_71f1444d": {
    "message": "Pri nalaganju medija je prišlo do napake."
  },
  "and_7fcc2911": {
    "message": "In"
  },
  "angle_c5b4ec50": {
    "message": "Kot"
  },
  "announcement_fb4cb645": {
    "message": "Obvestilo"
  },
  "announcement_list_da155734": {
    "message": "Seznam obvestil"
  },
  "announcements_a4b8ed4a": {
    "message": "Obvestila"
  },
  "apply_781a2546": {
    "message": "Uporabi"
  },
  "apply_changes_to_all_instances_of_this_icon_maker__2642f466": {
    "message": "Uveljavi spremembe za vse primerke te ikone ustvarjalnika ikon pri predmetu"
  },
  "approaches_the_limit_893aeec9": {
    "message": "Približuje se mejni vrednosti"
  },
  "approximately_e7965800": {
    "message": "Približno"
  },
  "apps_54d24a47": {
    "message": "Aplikacije"
  },
  "are_you_sure_you_want_to_cancel_changes_you_made_m_c5210496": {
    "message": "Ali ste prepričani, da želite preklicati? Spremembe, ki ste jih izvedli, morda ne bodo shranjene."
  },
  "arrows_464a3e54": {
    "message": "Puščice"
  },
  "art_icon_8e1daad": {
    "message": "Ikona umetnosti"
  },
  "aspect_ratio_will_be_preserved_cb5fdfb8": {
    "message": "Razmerje med širino in višino bo ohranjeno."
  },
  "assignment_976578a8": {
    "message": "Naloga"
  },
  "assignments_1e02582c": {
    "message": "Naloge:"
  },
  "asterisk_82255584": {
    "message": "Zvezdica"
  },
  "attributes_963ba262": {
    "message": "Lastnosti"
  },
  "audio_and_video_recording_not_supported_please_use_5ce3f0d7": {
    "message": "Snemanje zvoka in videoposnetkov ni podprto; uporabite drug brskalnik."
  },
  "audio_options_feb58e2c": {
    "message": "Možnosti zvoka"
  },
  "audio_options_tray_33a90711": {
    "message": "Trak z možnostmi zvoka"
  },
  "audio_player_for_title_20cc70d": {
    "message": "Predvajalnik zvoka za { title }"
  },
  "auto_saved_content_exists_would_you_like_to_load_t_fee528f2": {
    "message": "Obstaja samodejno shranjena vsebina. Ali želite namesto tega naložiti samodejno shranjeno vsebino?"
  },
  "available_folders_694d0436": {
    "message": "Razpoložljive mape"
  },
  "background_1bc88842": {
    "message": "Ozadje"
  },
  "backslash_b2d5442d": {
    "message": "Poševnica nazaj"
  },
  "bar_ec63ed6": {
    "message": "Vrstica"
  },
  "basic_554cdc0a": {
    "message": "Osnovno"
  },
  "because_501841b": {
    "message": "Zaradi"
  },
  "below_81d4dceb": {
    "message": "Spodaj"
  },
  "beta_cb5f307e": {
    "message": "Beta"
  },
  "big_circle_16b2e604": {
    "message": "Veliki krog"
  },
  "binomial_coefficient_ea5b9bb7": {
    "message": "Binomni koeficient"
  },
  "black_4cb01371": {
    "message": "Črna"
  },
  "blue_daf8fea9": {
    "message": "Modra"
  },
  "bold_applied_42d547b7": {
    "message": "Krepka pisava uporabljena"
  },
  "bold_removed_da474a5c": {
    "message": "Krepka pisava odstranjena"
  },
  "border_5b08b06d": {
    "message": "Obroba"
  },
  "bottom_15a2a9be": {
    "message": "Dno"
  },
  "bottom_third_5f5fec1d": {
    "message": "Tretja spodaj"
  },
  "bowtie_5f9629e4": {
    "message": "Metuljček"
  },
  "brick_f2656265": {
    "message": "Opeka"
  },
  "c_2001_acme_inc_283f7f80": {
    "message": "Avtorske pravice (c) 2001 Acme Inc."
  },
  "cancel_caeb1e68": {
    "message": "Prekliči"
  },
  "cap_product_3a5265a6": {
    "message": "Izdelek s pokrovom"
  },
  "caption_manager_aae0906f": {
    "message": "Upravitelj napisov"
  },
  "center_align_e68d9997": {
    "message": "Sredinska poravnava"
  },
  "centered_dot_64d5e378": {
    "message": "Središčna pika"
  },
  "centered_horizontal_dots_451c5815": {
    "message": "Sredične vodoravne pike"
  },
  "change_alt_text_92654906": {
    "message": "Spremeni nadomestno besedilo"
  },
  "change_heading_tag_to_paragraph_a61e3113": {
    "message": "Spremeni oznako naslova odstavka"
  },
  "change_only_this_heading_s_level_903cc956": {
    "message": "Spremeni samo raven tega naslova"
  },
  "change_text_color_1aecb912": {
    "message": "Spremeni barvo besedila"
  },
  "changes_will_apply_after_you_save_this_page_fb324e9d": {
    "message": "Spremembe bodo uveljavljene, ko shranite to stran."
  },
  "changes_you_made_may_not_be_saved_4e8db973": {
    "message": "Spremembe, ki ste jih izvedli, morda ne bodo shranjene."
  },
  "characters_9d897d1c": {
    "message": "Znaki"
  },
  "characters_no_spaces_485e5367": {
    "message": "Znaki (brez presledkov)"
  },
  "check_accessibility_3c78211c": {
    "message": "Preveri dostopnost"
  },
  "checking_for_accessibility_issues_fac18c6d": {
    "message": "Preverjanje težav z dostopnostjo"
  },
  "chi_54a32644": {
    "message": "Či"
  },
  "choose_caption_file_9c45bc4e": {
    "message": "Izberite datoteko spremnega besedila"
  },
  "choose_usage_rights_33683854": {
    "message": "Izberi pravice uporabe ..."
  },
  "circle_484abe63": {
    "message": "Krog"
  },
  "circle_unordered_list_9e3a0763": {
    "message": "nerazvrščeni seznam s krogi"
  },
  "clear_2084585f": {
    "message": "Počisti"
  },
  "clear_image_3213fe62": {
    "message": "Jasna slika"
  },
  "click_or_shift_click_for_the_html_editor_25d70bb4": {
    "message": "Za urejevalnik html kliknite ali kliknite med pritiskanjem tipke Shift."
  },
  "click_to_embed_imagename_c41ea8df": {
    "message": "Kliknite, da vdelate { imageName }."
  },
  "click_to_hide_preview_3c707763": {
    "message": "Kliknite, da skrijete predogled"
  },
  "click_to_insert_a_link_into_the_editor_c19613aa": {
    "message": "Kliknite, da vstavite povezavo v urejevalnik."
  },
  "click_to_show_preview_faa27051": {
    "message": "Kliknite, da prikažete predogled"
  },
  "close_a_menu_or_dialog_also_returns_you_to_the_edi_739079e6": {
    "message": "Zapri meni ali pogovorno okno Prav tako vas vrne v območje urejevalnika"
  },
  "close_accessibility_checker_29d1c51e": {
    "message": "Zapri orodje za preverjanje dostopnosti"
  },
  "close_d634289d": {
    "message": "Zapri"
  },
  "close_keyboard_shortcuts_modal_291ce074": {
    "message": "Zapri modalno okno za bližnjice"
  },
  "closed_caption_file_must_be_less_than_maxkb_kb_5880f752": {
    "message": "Datoteka z razširjenimi podnapisi mora biti manjša od { maxKb } kb"
  },
  "closed_captions_subtitles_e6aaa016": {
    "message": "Razširjeni podnapisi/podnapisi"
  },
  "clubs_suit_c1ffedff": {
    "message": "Klubi (obleka)"
  },
  "collab_575ac7bc": {
    "message": "Sodelovanje"
  },
  "collaborations_5c56c15f": {
    "message": "Skupinske naloge"
  },
  "collapse_to_hide_types_1ab46d2e": {
    "message": "Strni za skrivanje { types }"
  },
  "color_a363e1b0": {
    "message": "Barva"
  },
  "color_contrast_4c418add": {
    "message": "Barvni kontrast"
  },
  "color_contrast_ratio_687782f0": {
    "message": "Razmerje barvnega kontrasta"
  },
  "color_picker_6b359edf": {
    "message": "Orodje za izbiranje barv"
  },
  "color_picker_colorname_selected_ad4cf400": {
    "message": "Izbirnik barv ({ colorName } izbranih)"
  },
  "color_popup_af39810f": {
    "message": "Barvno pojavno okno"
  },
  "column_e1ae5c64": {
    "message": "Stolpec"
  },
  "column_group_1c062368": {
    "message": "Skupina stolpcev"
  },
  "complex_numbers_a543d004": {
    "message": "Kompleksna števila"
  },
  "computer_1d7dfa6f": {
    "message": "Računalnik"
  },
  "congruent_5a244acd": {
    "message": "Kongruentno"
  },
  "contains_311f37b7": {
    "message": "Vsebuje"
  },
  "content_1440204b": {
    "message": "Vsebina"
  },
  "content_in_the_editor_will_be_changed_press_cancel_d5bf3357": {
    "message": "Vsebina v urejevalniku bo spremenjena. Pritisnite Prekliči, da obdržite izvirno vsebino."
  },
  "content_is_still_being_uploaded_if_you_continue_it_8f06d0cb": {
    "message": "Vsebina se še vedno nalaga. Če nadaljujete, ne bo pravilno vdelana."
  },
  "content_subtype_5ce35e88": {
    "message": "Podvrsta vsebine"
  },
  "content_type_2cf90d95": {
    "message": "Vrsta vsebine"
  },
  "continue_to_youtube_content_a34f0f85": {
    "message": "Nadaljuj na vsebino YouTube"
  },
  "coproduct_e7838082": {
    "message": "Koprodukt"
  },
  "copyright_holder_66ee111": {
    "message": "Lastnik avtorskih pravic:"
  },
  "could_not_insert_content_itemtype_items_are_not_cu_638dfecd": {
    "message": "Vsebine ni mogoče vstaviti: V sistemu Canvas elementi »{ itemType }« trenutno niso podprti."
  },
  "count_40eced3b": {
    "message": "Število"
  },
  "count_plural_0_0_words_one_1_word_other_words_acf32eca": {
    "message": "{ count, plural,\n     =0 {0 besed}\n    one {1 beseda}\n  other {# besede}\n}"
  },
  "count_plural_one_item_loaded_other_items_loaded_857023b7": {
    "message": "{ count, plural,\n    one {# elementov je naloženih}\n  other {# elementi so naloženi}\n}"
  },
  "course_documents_104d76e0": {
    "message": "Dokumenti predmeta"
  },
  "course_files_62deb8f8": {
    "message": "Datoteke predmeta"
  },
  "course_files_a31f97fc": {
    "message": "Datoteke predmeta"
  },
  "course_images_f8511d04": {
    "message": "Slike predmeta"
  },
  "course_link_b369426": {
    "message": "Povezava do predmeta"
  },
  "course_links_b56959b9": {
    "message": "Povezave predmeta"
  },
  "course_media_ec759ad": {
    "message": "Mediji predmeta"
  },
  "course_navigation_dd035109": {
    "message": "Navigacija po predmetu"
  },
  "create_icon_110d6463": {
    "message": "Ustvari ikono"
  },
  "create_icon_maker_icon_c716bffe": {
    "message": "Ustvari ikono ustvarjalnika ikon"
  },
  "creative_commons_license_725584ae": {
    "message": "Licenca Creative Commons:"
  },
  "crop_image_41bf940c": {
    "message": "Obreži sliko"
  },
  "crop_image_807ebb08": {
    "message": "Obreži sliko"
  },
  "cup_product_14174434": {
    "message": "Izdelek za skodelico"
  },
  "current_image_f16c249c": {
    "message": "Trenutna slika"
  },
  "current_link_945a47ee": {
    "message": "Trenutna povezava"
  },
  "current_volume_level_c55ab825": {
    "message": "Trenutna raven glasnosti"
  },
  "custom_6979cd81": {
    "message": "Po meri"
  },
  "cyan_c1d5f68a": {
    "message": "Cijan"
  },
  "dagger_57e0f4e5": {
    "message": "Bodalo"
  },
  "date_added_ed5ad465": {
    "message": "Datum dodajanja"
  },
  "decorative_icon_9a7f3fc3": {
    "message": "Okrasna ikona"
  },
  "decorative_image_fde98579": {
    "message": "Dekorativna slika"
  },
  "decorative_type_upper_f2c95e3": {
    "message": "Dekorativni { TYPE_UPPER }"
  },
  "decrease_indent_d9cf469d": {
    "message": "Zmanjšaj zamik"
  },
  "decrease_rich_content_area_82068f64": {
    "message": "Zmanjšaj območje bogate vsebine"
  },
  "deep_purple_bb3e2907": {
    "message": "Temno škrlatna"
  },
  "default_9db103d": {
    "message": "Privzeto"
  },
  "default_bulleted_unordered_list_47079da8": {
    "message": "privzeti neurejeni seznam z alinejami"
  },
  "default_numerical_ordered_list_48dd3548": {
    "message": "privzeti številčno urejeni seznam"
  },
  "definite_integral_fe7ffed1": {
    "message": "Določeni integral"
  },
  "degree_symbol_4a823d5f": {
    "message": "Simbol stopinje"
  },
  "delimiters_4db4840d": {
    "message": "Ločila"
  },
  "delta_53765780": {
    "message": "Delta"
  },
  "describe_the_icon_f6a18823": {
    "message": "(Opišite ikono)"
  },
  "describe_the_type_ff448da5": {
    "message": "(Opišite { TYPE })"
  },
  "description_436c48d7": {
    "message": "Opis"
  },
  "details_98a31b68": {
    "message": "Podrobnosti"
  },
  "diagonal_dots_7d71b57e": {
    "message": "Diagonalne pike"
  },
  "diamond_b8dfe7ae": {
    "message": "Diamant"
  },
  "diamonds_suit_526abaaf": {
    "message": "Diamanti (obleka)"
  },
  "digamma_258ade94": {
    "message": "Digama"
  },
  "dimension_type_f5fa9170": {
    "message": "Vrsta mere"
  },
  "directionality_26ae9e08": {
    "message": "Usmerjenost"
  },
  "directly_edit_latex_b7e9235b": {
    "message": "Neposredno urejanje LaTeX"
  },
  "disable_preview_222bdf72": {
    "message": "Onemogoči predogled"
  },
  "discussion_6719c51d": {
    "message": "Razprava"
  },
  "discussions_a5f96392": {
    "message": "Razprave"
  },
  "discussions_index_6c36ced": {
    "message": "Kazalo razprav"
  },
  "disjoint_union_e74351a8": {
    "message": "Nepovezan spoj"
  },
  "display_options_315aba85": {
    "message": "Prikaz možnosti"
  },
  "display_text_link_opens_in_a_new_tab_75e9afc9": {
    "message": "Prikaži besedilno povezavo (se odpre v novem zavihku)"
  },
  "div_applied_49ad83fc": {
    "message": "Div uporabljen"
  },
  "div_removed_d13f8e17": {
    "message": "Div odstranjen"
  },
  "division_sign_72190870": {
    "message": "Znak za deljenje"
  },
  "document_678cd7bf": {
    "message": "Dokument"
  },
  "documents_81393201": {
    "message": "Dokumenti"
  },
  "done_54e3d4b6": {
    "message": "Dokončano"
  },
  "double_dagger_faf78681": {
    "message": "Dvojno bodalo"
  },
  "down_5831a426": {
    "message": "Navzdol"
  },
  "down_and_left_diagonal_arrow_40ef602c": {
    "message": "Diagonalna puščica navzdol in levo"
  },
  "down_and_right_diagonal_arrow_6ea0f460": {
    "message": "Diagonalna puščica navzdol in desno"
  },
  "download_filename_2baae924": {
    "message": "Prenesi { filename }"
  },
  "downward_arrow_cca52012": {
    "message": "Puščica navzdol"
  },
  "downward_pointing_triangle_2a12a601": {
    "message": "Navzdol usmerjeni trikotnik"
  },
  "drag_a_file_here_1bf656d5": {
    "message": "Datoteko povlecite sem"
  },
  "drag_and_drop_or_click_to_browse_your_computer_60772d6d": {
    "message": "Za brskanje po računalniku povlecite in spustite ali kliknite"
  },
  "drag_handle_use_up_and_down_arrows_to_resize_e29eae5c": {
    "message": "Ravnanje ob vlečenju. Za spremembo velikosti uporabite puščici gor in dol"
  },
  "due_multiple_dates_cc0ee3f5": {
    "message": "Roki: Več datumov"
  },
  "due_when_7eed10c6": {
    "message": "Roki: { when }"
  },
  "edit_alt_text_for_this_icon_instance_9c6fc5fd": {
    "message": "Uredite nadomestno besedilo za ta primerek ikone"
  },
  "edit_c5fbea07": {
    "message": "Uredi"
  },
  "edit_course_link_5a5c3c59": {
    "message": "Uredi povezavo do predmeta"
  },
  "edit_equation_f5279959": {
    "message": "Uredi enačbo"
  },
  "edit_existing_icon_maker_icon_5d0ebb3f": {
    "message": "Uredi obstoječo ikono ustvarjalnika ikon"
  },
  "edit_icon_2c6b0e91": {
    "message": "Uredi ikono"
  },
  "edit_link_7f53bebb": {
    "message": "Uredi povezavo"
  },
  "editor_status_bar_653f44ee": {
    "message": "Statusna vrstica urejevalnika"
  },
  "element_starting_with_start_91bf4c3b": {
    "message": "Element, ki se začne s/z { start }"
  },
  "embed_828fac4a": {
    "message": "Vdelaj"
  },
  "embed_code_314f1bd5": {
    "message": "Vdelaj kodo"
  },
  "embed_content_from_external_tool_3397ad2d": {
    "message": "Vdelaj vsebino iz zunanjega orodja"
  },
  "embed_image_1080badc": {
    "message": "Vdelaj sliko"
  },
  "embed_video_a97a64af": {
    "message": "Vdelajte videoposnetek"
  },
  "embedded_content_aaeb4d3d": {
    "message": "vdelano vsebino"
  },
  "empty_set_91a92df4": {
    "message": "Prazen nabor"
  },
  "encircled_dot_8f5e51c": {
    "message": "Obkrožena pika"
  },
  "encircled_minus_72745096": {
    "message": "Obkrožen minus"
  },
  "encircled_plus_36d8d104": {
    "message": "Obkrožen plus"
  },
  "encircled_times_5700096d": {
    "message": "Obkroženi časi"
  },
  "engineering_icon_f8f3cf43": {
    "message": "Ikona inženirstva"
  },
  "english_icon_25bfe845": {
    "message": "Angleška ikona"
  },
  "enter_a_media_title_81b490ec": {
    "message": "Vnesite naslov medija"
  },
  "enter_at_least_3_characters_to_search_4f037ee0": {
    "message": "Za iskanje vnesite vsaj 3 znake"
  },
  "enter_replacement_text_17631bbc": {
    "message": "vnesite nadomestno besedilo"
  },
  "enter_search_text_26cb4459": {
    "message": "vnesite besedilo za iskanje"
  },
  "epsilon_54bb8afa": {
    "message": "Epsilon"
  },
  "epsilon_variant_d31f1e77": {
    "message": "Epsilon (različica)"
  },
  "equals_sign_c51bdc58": {
    "message": "Znak enakosti"
  },
  "equation_1c5ac93c": {
    "message": "Enačba"
  },
  "equation_editor_39fbc3f1": {
    "message": "Urejevalnik enačb"
  },
  "equilibrium_6ff3040b": {
    "message": "Ravnotežje"
  },
  "equivalence_class_7b0f11c0": {
    "message": "Razred enakosti"
  },
  "equivalent_identity_654b3ce5": {
    "message": "Ekvivalent (identiteta)"
  },
  "eta_b8828f99": {
    "message": "Eta"
  },
  "exists_2e62bdaa": {
    "message": "Obstaja"
  },
  "exit_fullscreen_b7eb0aa4": {
    "message": "Izhod iz celotnega zaslona"
  },
  "expand_preview_by_default_2abbf9f8": {
    "message": "Privzeto razširi predogled"
  },
  "expand_to_see_types_f5d29352": {
    "message": "Razširi za prikaz { types }"
  },
  "external_link_d3f9e62a": {
    "message": "Zunanja povezava"
  },
  "external_tool_frame_70b32473": {
    "message": "Okvir zunanjega orodja"
  },
  "external_tools_6e77821": {
    "message": "Zunanja orodja"
  },
  "extra_large_b6cdf1ff": {
    "message": "Zelo veliko"
  },
  "extra_large_width_x_height_px_915571fa": {
    "message": "Zelo veliko ({ width } x { height }px)"
  },
  "extra_small_9ae33252": {
    "message": "Zelo majhen"
  },
  "extracurricular_icon_67c8ca42": {
    "message": "Zunajštudijska ikona"
  },
  "f_function_fe422d65": {
    "message": "F (funkcija)"
  },
  "fail_544e5dde": {
    "message": "NEOPRAVLJENO"
  },
  "failed_getting_file_contents_e9ea19f4": {
    "message": "Pridobivanje vsebine datoteke ni uspelo"
  },
  "failed_to_retrieve_content_from_external_tool_5899c213": {
    "message": "Vsebine iz zunanjega orodja ni bilo mogoče pridobiti"
  },
  "file_name_8fd421ff": {
    "message": "Ime datoteke"
  },
  "file_preview_21667a6e": {
    "message": "Predogled datoteke"
  },
  "file_preview_for_filename_ab314195": {
    "message": "Predogled datoteke za { fileName }"
  },
  "file_storage_quota_exceeded_b7846cd1": {
    "message": "Kvota prostora na disku je presežena"
  },
  "file_url_c12b64be": {
    "message": "URL datoteke"
  },
  "filename_file_icon_602eb5de": {
    "message": "Ikona datoteke { filename }"
  },
  "filename_image_preview_6cef8f26": {
    "message": "Predogled slike { filename }"
  },
  "filename_text_preview_e41ca2d8": {
    "message": "Predogled besedila { filename }"
  },
  "files_c300e900": {
    "message": "Datoteke"
  },
  "files_index_af7c662b": {
    "message": "Kazalo datotek"
  },
  "find_8d605019": {
    "message": "Najdi"
  },
  "find_and_replace_6e345933": {
    "message": "Najdi in zamenjaj"
  },
  "finish_bc343002": {
    "message": "Dokončaj"
  },
  "fix_heading_hierarchy_f60884c4": {
    "message": "Popravi hierarhijo naslovov"
  },
  "flat_music_76d5a5c3": {
    "message": "Ravno (glasba)"
  },
  "focus_element_options_toolbar_18d993e": {
    "message": "Orodna vrstica za izostritev možnosti elementov"
  },
  "folder_tree_fbab0726": {
    "message": "Drevo map"
  },
  "for_all_b919f972": {
    "message": "Za vse"
  },
  "format_4247a9c5": {
    "message": "Oblika zapisa"
  },
  "format_as_a_list_142210c3": {
    "message": "Oblikuj kot seznam"
  },
  "formatting_5b143aa8": {
    "message": "Oblikovanje"
  },
  "forward_slash_3f90f35e": {
    "message": "Poševnica naprej"
  },
  "found_auto_saved_content_3f6e4ca5": {
    "message": "Našli smo samodejno shranjeno vsebina"
  },
  "found_count_plural_0_results_one_result_other_resu_46aeaa01": {
    "message": "Najdeno (najden) je { count, plural,\n     =0 {# rezultatov}\n    one {# rezultat }\n  other {# rezultatov}\n}"
  },
  "fraction_41bac7af": {
    "message": "Ulomek"
  },
  "fullscreen_873bf53f": {
    "message": "Celoten zaslon"
  },
  "gamma_1767928": {
    "message": "Gama"
  },
  "generating_preview_45b53be0": {
    "message": "Generiranje predogleda ..."
  },
  "gif_png_format_images_larger_than_size_kb_are_not__7af3bdbd": {
    "message": "Slike v obliki GIF/PNG, večje od { size } KB, trenutno niso podprte."
  },
  "go_to_the_editor_s_menubar_e6674c81": {
    "message": "Pojdi v menijsko vrstico urejevalnika"
  },
  "go_to_the_editor_s_toolbar_a5cb875f": {
    "message": "Pojdi orodno vrstico urejevalnika"
  },
  "grades_a61eba0a": {
    "message": "Ocene"
  },
  "graphics_text_bc9568bc": {
    "message": "Besedilo grafike"
  },
  "greater_than_e98af662": {
    "message": "Večje od"
  },
  "greater_than_or_equal_b911949a": {
    "message": "Večje ali enako"
  },
  "greek_65c5b3f7": {
    "message": "grške"
  },
  "green_15af4778": {
    "message": "Zeleno"
  },
  "grey_a55dceff": {
    "message": "Siva"
  },
  "group_documents_8bfd6ae6": {
    "message": "Dokumenti skupine"
  },
  "group_files_4324f3df": {
    "message": "Datoteke skupine"
  },
  "group_files_82e5dcdb": {
    "message": "Datoteke skupine"
  },
  "group_images_98e0ac17": {
    "message": "Slike skupine"
  },
  "group_isomorphism_45b1458c": {
    "message": "Skupinski izomorfizem"
  },
  "group_link_63e626b3": {
    "message": "Povezava do skupine"
  },
  "group_links_9493129e": {
    "message": "Povezave do skupin"
  },
  "group_media_2f3d128a": {
    "message": "Mediji skupine"
  },
  "group_navigation_99f191a": {
    "message": "Navigacija po skupini"
  },
  "h_bar_bb94deae": {
    "message": "Vrstica H"
  },
  "hat_ea321e35": {
    "message": "Klobuk"
  },
  "header_column_f27433cb": {
    "message": "Stolpec z glavo"
  },
  "header_row_and_column_ec5b9ec": {
    "message": "Vrstica in stolpec z glavo"
  },
  "header_row_f33eb169": {
    "message": "Vrstica z glavo"
  },
  "heading_2_5b84eed2": {
    "message": "Glava 2"
  },
  "heading_3_2c83de44": {
    "message": "Glava 3"
  },
  "heading_4_b2e74be7": {
    "message": "Glava 4"
  },
  "heading_h_applied_eccd294d": {
    "message": "Naslov { h } uporabljen"
  },
  "heading_h_removed_745f24a6": {
    "message": "Naslov { h } odstranjen"
  },
  "heading_levels_should_not_be_skipped_3947c0e0": {
    "message": "Ravni naslovov ni dovoljeno preskočiti."
  },
  "heading_starting_with_start_42a3e7f9": {
    "message": "Naslov, ki se začne s/z { start }"
  },
  "headings_should_not_contain_more_than_120_characte_3c0e0cb3": {
    "message": "Naslovi ne smejo vsebovati več kot 120 znakov."
  },
  "health_icon_8d292eb5": {
    "message": "Ikona zdravstva"
  },
  "hearts_suit_e50e04ca": {
    "message": "Srca (obleka)"
  },
  "height_69b03e15": {
    "message": "Višina"
  },
  "hexagon_d8468e0d": {
    "message": "Šesterokotnik"
  },
  "hide_description_bfb5502e": {
    "message": "Skrij opis"
  },
  "hide_title_description_caf092ef": {
    "message": "Skrij opis { title }"
  },
  "highlight_an_element_to_activate_the_element_optio_60e1e56b": {
    "message": "Označite element, da aktivirate orodno vrstico z možnostmi elementa"
  },
  "home_351838cd": {
    "message": "Glavna stran"
  },
  "how_to_request_and_edit_captions_a49a9c6b": {
    "message": "Kako zahtevati in urejati napise?"
  },
  "html_code_editor_fd967a44": {
    "message": "urejevalnik kode html"
  },
  "html_editor_fb2ab713": {
    "message": "Urejevalnik HTML"
  },
  "i_have_obtained_permission_to_use_this_file_6386f087": {
    "message": "Pridobil sem dovoljenje za uporabo te datoteke."
  },
  "i_hold_the_copyright_71ee91b1": {
    "message": "Imam avtorske pravice."
  },
  "icon_215a1dc6": {
    "message": "Ikona"
  },
  "icon_8168b2f8": {
    "message": "ikona"
  },
  "icon_color_b86dd6d6": {
    "message": "Barva ikone"
  },
  "icon_maker_icons_cc560f7e": {
    "message": "Ikone ustvarjalnika ikon"
  },
  "icon_options_7e32746e": {
    "message": "Možnosti ikon"
  },
  "icon_options_tray_2b407977": {
    "message": "Pladenj z možnostmi ikon"
  },
  "icon_preview_1782a1d9": {
    "message": "Predogled ikon"
  },
  "icon_shape_30b61e7": {
    "message": "Oblika ikone"
  },
  "icon_size_9353edea": {
    "message": "Velikost ikone"
  },
  "if_left_empty_link_text_will_display_as_course_lin_2a34eedb": {
    "message": "Če povezavo pustite prazno, bo besedilo prikazano kot ime povezave na predmet"
  },
  "if_usage_rights_are_required_the_file_will_not_pub_841e276e": {
    "message": "Če so zahtevane pravice uporabe, datoteka ne bo objavljena, dokler to ni omogočeno na strani Datoteke."
  },
  "if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5": {
    "message": "Če ne izberete pravic uporabe zdaj, ta datoteka po nalaganju ne bo objavljena."
  },
  "image_8ad06": {
    "message": "Slika"
  },
  "image_c1c98202": {
    "message": "slika"
  },
  "image_filenames_should_not_be_used_as_the_alt_attr_bcfd7780": {
    "message": "Imen datotek slik ni dovoljeno uporabljati kot nadomestno lastnost za opis vsebine slike."
  },
  "image_options_5412d02c": {
    "message": "Možnosti slike"
  },
  "image_options_tray_90a46006": {
    "message": "Vrstica z možnostmi slike"
  },
  "image_to_crop_3a34487d": {
    "message": "Slika za obrezovanje"
  },
  "image_with_filename_file_aacd7180": {
    "message": "Slika z imenom datoteke { file }"
  },
  "images_7ce26570": {
    "message": "Slike"
  },
  "images_should_include_an_alt_attribute_describing__b86d6a86": {
    "message": "Slike morajo vsebovati nadomestno lastnost, ki opisuje vsebino slike."
  },
  "imaginary_portion_of_complex_number_2c733ffa": {
    "message": "Namišljeni del (kompleksnega števila)"
  },
  "in_element_of_19ca2f33": {
    "message": "V (element)"
  },
  "increase_indent_6af90f7c": {
    "message": "Povečaj zamik"
  },
  "increase_rich_content_area_340b775": {
    "message": "Povečaj območje bogate vsebine"
  },
  "indefinite_integral_6623307e": {
    "message": "Nedoločeni integral"
  },
  "index_of_max_80dcf7a5": {
    "message": "{ index } od { max }"
  },
  "indigo_2035fc55": {
    "message": "Indigo"
  },
  "inference_fed5c960": {
    "message": "Sklepanje"
  },
  "infinity_7a10f206": {
    "message": "Neskončnost"
  },
  "input_field_for_alpha_678265fd": {
    "message": "Vnosno polje za alfa"
  },
  "input_field_for_blue_561e020a": {
    "message": "Vnosno polje za modro"
  },
  "input_field_for_green_67f8b2b6": {
    "message": "Vnosno polje za zeleno"
  },
  "input_field_for_red_86a84615": {
    "message": "Vnosno polje za rdečo"
  },
  "insert_593145ef": {
    "message": "Vstavi"
  },
  "insert_link_6dc23cae": {
    "message": "Vstavi povezavo"
  },
  "insert_math_equation_57c6e767": {
    "message": "Vstavi matematično enačbo"
  },
  "integers_336344e1": {
    "message": "Cela števila"
  },
  "intersection_cd4590e4": {
    "message": "Presek"
  },
  "invalid_description_991e23bb": {
    "message": "Neveljaven opis"
  },
  "invalid_entry_f7d2a0f5": {
    "message": "Neveljaven vnos."
  },
  "invalid_file_c11ba11": {
    "message": "Neveljavna datoteka"
  },
  "invalid_file_type_881cc9b2": {
    "message": "Neveljavna vrsta datoteke"
  },
  "invalid_url_cbde79f": {
    "message": "Neveljaven naslov URL"
  },
  "iota_11c932a9": {
    "message": "Jota"
  },
  "issue_num_total_f94536cf": {
    "message": "Težava { num }/{ total }"
  },
  "italic_applied_8f59a684": {
    "message": "Ležeča pisava uporabljena"
  },
  "italic_removed_17cbab6f": {
    "message": "Ležeča pisava odstranjena"
  },
  "kappa_2f14c816": {
    "message": "Kapa"
  },
  "kappa_variant_eb64574b": {
    "message": "Kapa (različica)"
  },
  "keyboard_shortcuts_ed1844bd": {
    "message": "Bližnjice"
  },
  "keyboards_navigate_to_links_using_the_tab_key_two__5fab8c82": {
    "message": "Navigacija do povezav poteka s tabulatorkami. Dve sosednji povezavi, ki usmerjata na isti cilj, lahko zmedeta uporabnike tipkovnic."
  },
  "lambda_4f602498": {
    "message": "Lambda"
  },
  "language_arts_icon_a798b0f8": {
    "message": "Ikona za jezikovni predmet"
  },
  "languages_icon_9d20539": {
    "message": "Ikona za jezike"
  },
  "large_9c5e80e7": {
    "message": "Velika"
  },
  "large_text_e7ba08cd": {
    "message": "Veliko besedilo"
  },
  "large_width_x_height_px_c61c2fd": {
    "message": "Veliko ({ width } x { height }px)"
  },
  "learn_ad3b3505": {
    "message": "Učenje"
  },
  "learn_more_about_adjacent_links_2cb9762c": {
    "message": "Več o sosednjih povezavah"
  },
  "learn_more_about_color_contrast_c019dfb9": {
    "message": "Več o barvnem kontrastu"
  },
  "learn_more_about_organizing_page_headings_8a7caa2e": {
    "message": "Več o organiziranju naslovov strani"
  },
  "learn_more_about_proper_page_heading_structure_d2959f2d": {
    "message": "Več o pravilni strukturi naslovov strani"
  },
  "learn_more_about_table_headers_5f5ee13": {
    "message": "Več o glavah preglednic"
  },
  "learn_more_about_using_alt_text_for_images_5698df9a": {
    "message": "Več o uporabi nadomestnega besedila za slike"
  },
  "learn_more_about_using_captions_with_tables_36fe496f": {
    "message": "Več o uporabi napisov pri preglednicah"
  },
  "learn_more_about_using_filenames_as_alt_text_264286af": {
    "message": "Več o uporabi imen datotek kot nadomestno besedilo"
  },
  "learn_more_about_using_lists_4e6eb860": {
    "message": "Več o uporabi seznamov"
  },
  "learn_more_about_using_scope_attributes_with_table_20df49aa": {
    "message": "Več o uporabi atributov obsega pri preglednicah"
  },
  "leave_as_is_4facfe55": {
    "message": "Ne spreminjaj"
  },
  "left_3ea9d375": {
    "message": "Levo"
  },
  "left_align_43d95491": {
    "message": "Leva poravnava"
  },
  "left_angle_bracket_c87a6d07": {
    "message": "Levi kotni oklepaj"
  },
  "left_arrow_4fde1a64": {
    "message": "Puščica za pomik v levo"
  },
  "left_arrow_with_hook_5bfcad93": {
    "message": "Puščica levo s kljukico"
  },
  "left_ceiling_ee9dd88a": {
    "message": "Levi oglati oklepaj"
  },
  "left_curly_brace_1726fb4": {
    "message": "Levi zaviti oklepaj"
  },
  "left_downard_harpoon_arrow_1d7b3d2e": {
    "message": "Harpunska puščica levo navzdol"
  },
  "left_floor_29ac2274": {
    "message": "Spodnji levi oglati oklepaj"
  },
  "left_to_right_e9b4fd06": {
    "message": "Od leve proti desni"
  },
  "left_upward_harpoon_arrow_3a562a96": {
    "message": "Harpunska puščica levo navzgor"
  },
  "leftward_arrow_1e4765de": {
    "message": "Puščica levo"
  },
  "leftward_pointing_triangle_d14532ce": {
    "message": "Levo usmerjeni trikotnik"
  },
  "less_than_a26c0641": {
    "message": "Manjše kot"
  },
  "less_than_or_equal_be5216cb": {
    "message": "Manjše ali enako"
  },
  "library_icon_ae1e54cf": {
    "message": "Ikona knjižnice"
  },
  "light_blue_5374f600": {
    "message": "Svetlo modra"
  },
  "link_7262adec": {
    "message": "Povezava"
  },
  "link_options_a16b758b": {
    "message": "Možnosti povezave"
  },
  "link_type_linktypemessage_c6d26815": {
    "message": "vrsta povezave: { linkTypeMessage }"
  },
  "link_with_text_starting_with_start_b3fcbe71": {
    "message": "Poveži z besedilom, ki se začne s/z { start }"
  },
  "links_14b70841": {
    "message": "Povezave"
  },
  "links_to_an_external_site_de74145d": {
    "message": "Povezave na zunanje mesto."
  },
  "lists_cd1336fc": {
    "message": "Seznami"
  },
  "lists_should_be_formatted_as_lists_f862de8d": {
    "message": "Seznami morajo biti oblikovani kot seznami."
  },
  "load_more_35d33c7": {
    "message": "Naloži več"
  },
  "loading_25990131": {
    "message": "Nalaganje ..."
  },
  "loading_bde52856": {
    "message": "Nalaganje"
  },
  "loading_closed_captions_subtitles_failed_95ceef47": {
    "message": "nalaganje razširjenih podnapisov/podnapisov ni uspelo."
  },
  "loading_external_tool_d839042c": {
    "message": "Nalaganje zunanjega orodja"
  },
  "loading_failed_b3524381": {
    "message": "Nalaganje ni uspelo ..."
  },
  "loading_failed_e6a9d8ef": {
    "message": "Nalaganje ni uspelo."
  },
  "loading_folders_d8b5869e": {
    "message": "Nalaganje map"
  },
  "loading_placeholder_for_filename_792ef5e8": {
    "message": "Nalaganje označbe mesta za { fileName }"
  },
  "loading_please_wait_d276220a": {
    "message": "Nalaganje, počakajte"
  },
  "loading_preview_9f077aa1": {
    "message": "Nalagam predogled"
  },
  "lock_speed_at_1x_57d4f815": {
    "message": "Zakleni hitrost pri 1x"
  },
  "locked_762f138b": {
    "message": "Zaklenjeno"
  },
  "logical_equivalence_76fca396": {
    "message": "Logična enakovrednost"
  },
  "logical_equivalence_short_8efd7b4f": {
    "message": "Logična enakovrednost (kratka)"
  },
  "logical_equivalence_short_and_thick_1e1f654d": {
    "message": "Logična enakovrednost (kratka in debela)"
  },
  "logical_equivalence_thick_662dd3f2": {
    "message": "Logična enakovrednost (debela)"
  },
  "low_horizontal_dots_cc08498e": {
    "message": "Spodnje vodoravne pike"
  },
  "magenta_4a65993c": {
    "message": "Magenta"
  },
  "maps_to_e5ef7382": {
    "message": "Zemljevidi do"
  },
  "math_icon_ad4e9d03": {
    "message": "Ikona matematike"
  },
  "media_af190855": {
    "message": "Mediji"
  },
  "media_file_is_processing_please_try_again_later_58a6d49": {
    "message": "Predstavnostna datoteka je v obdelavi. Poskusite znova pozneje."
  },
  "media_options_saved_560c4ec8": {
    "message": "Medijske možnosti shranjene."
  },
  "media_title_2112243b": {
    "message": "Naslov medija"
  },
  "medium_5a8e9ead": {
    "message": "Srednja"
  },
  "medium_width_x_height_px_b076f6b6": {
    "message": "Srednje ({ width } x { height }px)"
  },
  "merge_links_2478df96": {
    "message": "Spoji povezave"
  },
  "mic_a7f3d311": {
    "message": "Mikrofon"
  },
  "microphone_disabled_15c83130": {
    "message": "Mikrofon onemogočen"
  },
  "middle_27dc1d5": {
    "message": "Sredina"
  },
  "minimize_file_preview_da911944": {
    "message": "Minimiziraj predogled datoteke"
  },
  "minimize_video_20aa554b": {
    "message": "Minimiziraj videoposnetek"
  },
  "minus_fd961e2e": {
    "message": "Minus"
  },
  "minus_plus_3461f637": {
    "message": "Minus/plus"
  },
  "misc_3b692ea7": {
    "message": "Razno"
  },
  "miscellaneous_e9818229": {
    "message": "Drugo"
  },
  "module_90d9fd32": {
    "message": "Modul"
  },
  "modules_c4325335": {
    "message": "Moduli"
  },
  "moving_image_to_crop_directionword_6f66cde2": {
    "message": "Premikam sliko za obrezovanje { directionWord }"
  },
  "mu_37223b8b": {
    "message": "Mu"
  },
  "multi_color_image_63d7372f": {
    "message": "Večbarvna slika"
  },
  "multiplication_sign_15f95c22": {
    "message": "Znak za množenje"
  },
  "music_icon_4db5c972": {
    "message": "Ikona glasbe"
  },
  "my_files_2f621040": {
    "message": "Moje datoteke"
  },
  "n_th_root_9991a6e4": {
    "message": "N-ti koren"
  },
  "nabla_1e216d25": {
    "message": "Nabla"
  },
  "name_1aed4a1b": {
    "message": "Ime"
  },
  "name_color_ceec76ff": {
    "message": "{ name } ({ color })"
  },
  "natural_music_54a70258": {
    "message": "Naravna (glasba)"
  },
  "natural_numbers_3da07060": {
    "message": "Naravna števila"
  },
  "navigate_through_the_menu_or_toolbar_415a4e50": {
    "message": "Navigirajte skozi meni ali orodno vrstico"
  },
  "navigation_ee9af92d": {
    "message": "Navigacija"
  },
  "nested_greater_than_d852e60d": {
    "message": "Ugnezdeni znak za večje kot"
  },
  "nested_less_than_27d17e58": {
    "message": "Ugnezdeni znak za manjše kot"
  },
  "new_quiz_34aacba6": {
    "message": "Nov kviz"
  },
  "next_40e12421": {
    "message": "Naprej"
  },
  "next_findtext_9d69f0fe": {
    "message": "Naslednji { findText }"
  },
  "no_accessibility_issues_were_detected_f8d3c875": {
    "message": "Ni zaznanih težav z dostopnostjo."
  },
  "no_announcements_created_yet_c44a94f4": {
    "message": "Ustvarjeno ni še nobeno obvestilo."
  },
  "no_announcements_found_20185afc": {
    "message": "Najti ni mogoče nobenega obvestila."
  },
  "no_assignments_created_yet_1b236d87": {
    "message": "Ustvarjena ni še nobena naloga."
  },
  "no_assignments_found_79e46d7f": {
    "message": "Najti ni mogoče nobene naloge."
  },
  "no_changes_to_save_d29f6e91": {
    "message": "Ni sprememb, ki bi jih bilo mogoče shraniti."
  },
  "no_discussions_created_yet_ff99abe3": {
    "message": "Ustvarjena ni še nobena razprava."
  },
  "no_discussions_found_9284063b": {
    "message": "Najti ni mogoče nobene razprave."
  },
  "no_e16d9132": {
    "message": "Ne"
  },
  "no_file_chosen_9a880793": {
    "message": "Izbrana ni nobena datoteka"
  },
  "no_headers_9bc7dc7f": {
    "message": "Ni glav."
  },
  "no_modules_created_yet_c71b6d4d": {
    "message": "Ustvarjen ni še noben modul."
  },
  "no_modules_found_2df43a40": {
    "message": "Najti ni mogoče nobenega modula."
  },
  "no_pages_created_yet_c379fa6e": {
    "message": "Ustvarjena ni še nobena stran."
  },
  "no_pages_found_6799350": {
    "message": "Najti ni mogoče nobene strani."
  },
  "no_preview_is_available_for_this_file_f940114a": {
    "message": "Za to datoteko predogled ni na voljo."
  },
  "no_quizzes_created_yet_1a2370b9": {
    "message": "Ustvarjen ni še noben kviz."
  },
  "no_quizzes_found_c80c537a": {
    "message": "Najti ni mogoče nobenega kviza."
  },
  "no_results_940393cf": {
    "message": "Ni rezultatov."
  },
  "no_results_found_58717065": {
    "message": "Ni rezultatov."
  },
  "no_results_found_for_filterterm_ad1b04c8": {
    "message": "Ni najdenih rezultatov za { filterTerm }"
  },
  "no_video_1ed00b26": {
    "message": "Ni videoposnetek"
  },
  "none_3b5e34d2": {
    "message": "Brez"
  },
  "none_selected_b93d56d2": {
    "message": "Nobena ni izbrana"
  },
  "normal_text_7b03da48": {
    "message": "Običajno besedilo"
  },
  "not_equal_6e2980e6": {
    "message": "Ni enako"
  },
  "not_in_not_an_element_of_fb1ffb54": {
    "message": "Ni del (ni element)"
  },
  "not_negation_1418ebb8": {
    "message": "Ne (negacija)"
  },
  "not_subset_dc2b5e84": {
    "message": "Ni podmnožica"
  },
  "not_subset_strict_23d282bf": {
    "message": "Ni podnabor (strogo)"
  },
  "not_superset_5556b913": {
    "message": "Ni nadnabor"
  },
  "not_superset_strict_24e06f36": {
    "message": "Ni nadnabor (strogo)"
  },
  "nu_1c0f6848": {
    "message": "Nu"
  },
  "octagon_e48be9f": {
    "message": "Osmerokotnik"
  },
  "olive_6a3e4d6b": {
    "message": "Olivna"
  },
  "omega_8f2c3463": {
    "message": "Omega"
  },
  "one_of_the_following_styles_must_be_added_to_save__1de769aa": {
    "message": "Za shranjevanje ikone je treba dodati enega od naslednjih slogov: Barva ikone, velikost orisa, besedilo ikone ali slika"
  },
  "one_or_more_files_failed_to_paste_please_try_uploa_7fa39dd3": {
    "message": "Lepljenje ene ali več datotek ni uspelo. Poskusite naložiti ali povleči in spustiti datoteke."
  },
  "open_circle_e9bd069": {
    "message": "Odprti krog"
  },
  "open_this_keyboard_shortcuts_dialog_9658b83a": {
    "message": "Odpri to pogovorno okno z bližnjicami"
  },
  "open_title_application_fd624fc5": {
    "message": "Odpri aplikacijo { title }"
  },
  "operators_a2ef9a93": {
    "message": "Upravljavci"
  },
  "options_3ab0ea65": {
    "message": "Možnosti"
  },
  "or_9b70ccaa": {
    "message": "Ali"
  },
  "orange_81386a62": {
    "message": "Oranžno"
  },
  "ordered_and_unordered_lists_cfadfc38": {
    "message": "Urejeni in neurejeni seznami"
  },
  "other_editor_shortcuts_may_be_found_at_404aba4a": {
    "message": "Druge bližnjice urejevalnika je mogoče najti na"
  },
  "outline_color_3ef2cea7": {
    "message": "Barva orisa"
  },
  "outline_size_a6059a21": {
    "message": "Velikost orisa"
  },
  "p_is_not_a_valid_protocol_b1c4efaa": {
    "message": "{ p } ni veljaven protokol."
  },
  "page_50c4823d": {
    "message": "Stran"
  },
  "pages_e5414c2c": {
    "message": "Strani"
  },
  "paragraph_5e5ad8eb": {
    "message": "Odstavek"
  },
  "paragraph_applied_959b3fe5": {
    "message": "Odstavek uporabljen"
  },
  "paragraph_removed_d09320e": {
    "message": "Odstavek odstranjen"
  },
  "paragraph_starting_with_start_a59923f8": {
    "message": "Odstavek, ki se začne s/z { start }"
  },
  "parallel_d55d6e38": {
    "message": "Vzporedno"
  },
  "partial_derivative_4a9159df": {
    "message": "Delno (izpeljanka)"
  },
  "pass_1c19a2b3": {
    "message": "OPRAVLJENO"
  },
  "paste_5963d1c1": {
    "message": "Prilepi"
  },
  "pause_12af3bb4": {
    "message": "Začasna zaustavitev"
  },
  "pentagon_17d82ea3": {
    "message": "Peterokotnik"
  },
  "people_b4ebb13c": {
    "message": "Sodelujoči"
  },
  "percentage_34ab7c2c": {
    "message": "Odstotek"
  },
  "percentage_must_be_a_number_8033c341": {
    "message": "Odstotek mora biti številka"
  },
  "percentage_must_be_at_least_percentage_a98ca8fc": {
    "message": "Odstotek mora biti najmanj { percentage }%"
  },
  "performing_arts_icon_f3497486": {
    "message": "Ikona odrskih umetnosti"
  },
  "perpendicular_7c48ede4": {
    "message": "Pravokotno"
  },
  "phi_4ac33b6d": {
    "message": "Fi"
  },
  "phi_variant_c9bb3ac5": {
    "message": "Fi (različica)"
  },
  "physical_education_icon_d7dffd3e": {
    "message": "Ikona športne vzgoje"
  },
  "pi_dc4f0bd8": {
    "message": "Pi"
  },
  "pi_variant_10f5f520": {
    "message": "Pi (različica)"
  },
  "pick_a_color_557abfb0": {
    "message": "Izberite barvo"
  },
  "pink_68ad45cb": {
    "message": "Rožnato"
  },
  "pixels_52ece7d1": {
    "message": "Slikovne pike"
  },
  "pixels_must_be_at_least_width_x_height_px_e965edd5": {
    "message": "Slikovne pike morajo biti najmanj { width } x { height } px"
  },
  "play_1a47eaa7": {
    "message": "Predvajaj"
  },
  "play_media_comment_35257210": {
    "message": "Predvajaj komentar v obliki medija."
  },
  "play_media_comment_by_name_from_createdat_c230123d": {
    "message": "Predvajaj komentar v obliki medija { name }, ki je bil ustvarjen ob/dne { createdAt }."
  },
  "player_layout_14e09a29": {
    "message": "Razporeditev predvajalnika"
  },
  "please_allow_canvas_to_access_your_microphone_and__dc2c3079": {
    "message": "Sistemu Canvas dovolite dostop do mikrofona in spletne kamere."
  },
  "please_choose_a_file_c2449cc": {
    "message": "Izberite datoteko"
  },
  "please_enter_a_file_name_f159edc1": {
    "message": "Vnesite ime datoteke"
  },
  "please_enter_a_valid_video_url_from_a_supported_pl_30dc0596": {
    "message": "Vnesite veljaven URL videoposnetka s podprte platforme."
  },
  "please_select_a_file_of_a_supported_type_1fc578f2": {
    "message": "Izberite datoteko podprte vrste"
  },
  "plus_d43cd4ec": {
    "message": "Plus"
  },
  "plus_minus_f8be2e83": {
    "message": "Plus/minus"
  },
  "posted_when_a578f5ab": {
    "message": "Objavljeno: { when }"
  },
  "power_set_4f26f316": {
    "message": "Potenčna množica"
  },
  "precedes_196b9aef": {
    "message": "Predhodnik"
  },
  "precedes_equal_20701e84": {
    "message": "Predhodnik enakosti"
  },
  "preformatted_d0670862": {
    "message": "Predoblikovano"
  },
  "prepend_findtext_append_8e0e769a": {
    "message": "{ prepend }{ findText }{ append }"
  },
  "prev_f82cbc48": {
    "message": "Nazaj"
  },
  "preview_53003fd2": {
    "message": "Predogled"
  },
  "preview_a3f8f854": {
    "message": "PREDOGLED"
  },
  "preview_in_overlay_ed772c46": {
    "message": "Predogled v prekrivnem elementu"
  },
  "preview_inline_9787330": {
    "message": "Vstavljen predogled"
  },
  "previous_bd2ac015": {
    "message": "Nazaj"
  },
  "previous_findtext_8dfbfd30": {
    "message": "Prejšnji { findText }"
  },
  "previously_chosen_colors_f1338315": {
    "message": "Prej izbrane barve"
  },
  "prime_917ea60e": {
    "message": "Pra"
  },
  "prime_numbers_13464f61": {
    "message": "Praštevila"
  },
  "product_39cf144f": {
    "message": "Zmnožek"
  },
  "proportional_f02800cc": {
    "message": "Sorazmerno"
  },
  "protocol_must_be_ftp_http_https_mailto_skype_tel_o_73beb4f8": {
    "message": "Protokol mora biti ftp, http, https, mailto, skype, tel ali pa ga izpustite"
  },
  "psi_e3f5f0f7": {
    "message": "Psi"
  },
  "published_c944a23d": {
    "message": "objavljeno"
  },
  "published_when_302d8e23": {
    "message": "Objavljeno: { when }"
  },
  "pumpkin_904428d5": {
    "message": "Buča"
  },
  "purple_7678a9fc": {
    "message": "Škrlatno"
  },
  "quaternions_877024e0": {
    "message": "Kvaternioni"
  },
  "quiz_e0dcce8f": {
    "message": "Kviz"
  },
  "quizzes_7e598f57": {
    "message": "Kvizi"
  },
  "rational_numbers_80ddaa4a": {
    "message": "Racionalne števila"
  },
  "real_numbers_7c99df94": {
    "message": "Realna števila"
  },
  "real_portion_of_complex_number_7dad33b5": {
    "message": "Realni del (kompleksnega števila)"
  },
  "record_7c9448b": {
    "message": "Posnemi"
  },
  "record_upload_media_5fdce166": {
    "message": "Posnemi/naloži medije"
  },
  "recording_98da6bda": {
    "message": "Snemanje"
  },
  "red_8258edf3": {
    "message": "Rdeče"
  },
  "relationships_6602af70": {
    "message": "Razmerja"
  },
  "religion_icon_246e0be1": {
    "message": "Ikona religije"
  },
  "remove_f47dc62a": {
    "message": "Odstrani"
  },
  "remove_filename_3ea029f6": {
    "message": "Odstrani { filename }"
  },
  "remove_heading_style_5fdc8855": {
    "message": "Odstrani slog naslova"
  },
  "remove_link_d1f2f4d0": {
    "message": "Odstrani povezavo"
  },
  "replace_all_d3d68b3": {
    "message": "Zamenjaj vse"
  },
  "replace_all_findtext_with_replacetext_da574b32": {
    "message": "Zamenjaj vse { findText } s/z { replaceText }"
  },
  "replace_e61834a7": {
    "message": "Zamenjaj"
  },
  "replace_findtext_with_replacetext_7b5c7fb3": {
    "message": "Zamenjaj { findText } s/z { replaceText }"
  },
  "replace_with_eeff01ad": {
    "message": "Zamenjaj s/z"
  },
  "replaced_alertfindtext_with_alertreplacetext_de5c1795": {
    "message": "Zamenjano { alertFindText } s/z { alertReplaceText }"
  },
  "replaced_all_alertfindtext_with_alertreplacetext_83fdfe59": {
    "message": "Zamenjano vse { alertFindText } s/z { alertReplaceText }"
  },
  "reset_95a81614": {
    "message": "Obnovi"
  },
  "resize_ec83d538": {
    "message": "Spremeni velikost"
  },
  "restore_auto_save_deccd84b": {
    "message": "Obnovim samodejno shranjeno vsebino?"
  },
  "result_index_of_max_7db5ad8b": {
    "message": "Rezultat { index } od { max }."
  },
  "reverse_turnstile_does_not_yield_7558be06": {
    "message": "Reverzni vrtilni križ (ni odnosa)"
  },
  "rho_a0244a36": {
    "message": "Ro"
  },
  "rho_variant_415245cd": {
    "message": "Ro (različica)"
  },
  "rich_content_editor_2708ef21": {
    "message": "Urejevalnik"
  },
  "rich_text_area_press_oskey_f8_for_rich_content_edi_c2f651d": {
    "message": "Območje besedila Pritisnite { OSKey }+F8 za bližnjice do urejevalnika."
  },
  "right_71ffdc4d": {
    "message": "Desno"
  },
  "right_align_39e7a32a": {
    "message": "Desna poravnava"
  },
  "right_angle_bracket_d704e2d6": {
    "message": "Desni kotni oklepaj"
  },
  "right_arrow_35e0eddf": {
    "message": "Puščica desno"
  },
  "right_arrow_with_hook_29d92d31": {
    "message": "Puščica desno s kljukico"
  },
  "right_ceiling_839dc744": {
    "message": "Desni oglati oklepaj"
  },
  "right_curly_brace_5159d5cd": {
    "message": "Desni zaviti oklepaj"
  },
  "right_downward_harpoon_arrow_d71b114f": {
    "message": "Harpunska puščica desno navzdol"
  },
  "right_floor_5392d5cf": {
    "message": "Desni oglati oklepaj"
  },
  "right_to_left_9cfb092a": {
    "message": "Od desne proti levi"
  },
  "right_upward_harpoon_arrow_f5a34c73": {
    "message": "Harpunska puščica desno navzgor"
  },
  "rightward_arrow_32932107": {
    "message": "Puščica desno"
  },
  "rightward_pointing_triangle_60330f5c": {
    "message": "Desno usmerjeni trikotnik"
  },
  "rotate_image_90_degrees_2ab77c05": {
    "message": "Zasuk slike za –90 stopinj"
  },
  "rotate_image_90_degrees_6c92cd42": {
    "message": "Zasuk slike za 90 stopinj"
  },
  "rotation_9699c538": {
    "message": "Rotacija"
  },
  "row_fc0944a7": {
    "message": "Vrstica"
  },
  "row_group_979f5528": {
    "message": "Skupina vrstic"
  },
  "sadly_the_pretty_html_editor_is_not_keyboard_acces_50da7665": {
    "message": "Žal urejevalnik Pretty HTML Editor ni dostopen s tipkovnico. Tukaj lahko dostopate do surovega urejevalnika HTML."
  },
  "save_11a80ec3": {
    "message": "Shrani"
  },
  "save_copy_ca63944e": {
    "message": "Shrani izvod"
  },
  "save_media_cb9e786e": {
    "message": "Shrani medije"
  },
  "saved_icon_maker_icons_df86e2a1": {
    "message": "Shranjene ikone ustvarjalnika ikon"
  },
  "screen_readers_cannot_determine_what_is_displayed__6a5842ab": {
    "message": "Brez nadomestnega besedila bralniki zaslonov ne morejo določiti, kaj je prikazano na sliki, imena datotek pa so pogosto nizi številk in črk brez smisla, ki ne opisujejo konteksta ali pomena."
  },
  "screen_readers_cannot_determine_what_is_displayed__6f1ea667": {
    "message": "Brez nadomestnega besedila, ki opisuje vsebino in pomen slike, bralniki zaslonov ne morejo določiti, kaj je prikazano na sliki. Nadomestno besedilo mora biti enostavno in jedrnato."
  },
  "screen_readers_cannot_determine_what_is_displayed__a57e6723": {
    "message": "Brez nadomestnega besedila, ki opisuje vsebino in pomen slike, bralniki zaslonov ne morejo določiti, kaj je prikazano na sliki."
  },
  "screen_readers_cannot_interpret_tables_without_the_bd861652": {
    "message": "Bralniki zaslonov ne morejo tolmačiti preglednic brez pravilne zgradbe. Glave preglednic zagotavljajo smer in obseg vsebine."
  },
  "screen_readers_cannot_interpret_tables_without_the_e62912d5": {
    "message": "Bralniki zaslonov ne morejo tolmačiti preglednic brez pravilne zgradbe. Spremno besedilo preglednic opisuje kontekst in splošno razumevanje preglednice."
  },
  "screen_readers_cannot_interpret_tables_without_the_f0bdec0f": {
    "message": "Bralniki zaslonov ne morejo tolmačiti preglednic brez pravilne zgradbe. Glave preglednic zagotavljajo smeri in pregled vsebine."
  },
  "script_l_42a7b254": {
    "message": "Skript L"
  },
  "search_280d00bd": {
    "message": "Iskanje"
  },
  "select_audio_source_21043cd5": {
    "message": "Izberi zvočni vir"
  },
  "select_crop_shape_d441feeb": {
    "message": "Izberite obliko izrezovanja"
  },
  "select_language_7c93a900": {
    "message": "Izberite jezik"
  },
  "select_video_source_1b5c9dbe": {
    "message": "Izberi videovir"
  },
  "selected_274ce24f": {
    "message": "Izbrano"
  },
  "selected_linkfilename_c093b1f2": {
    "message": "Izbrano { linkFileName }"
  },
  "selection_b52c4c5e": {
    "message": "Izbira"
  },
  "set_header_scope_8c548f40": {
    "message": "Nastavi obseg glave"
  },
  "set_minus_b46e9b88": {
    "message": "Nastavi minus"
  },
  "set_table_header_cfab13a0": {
    "message": "Nastavi glavo preglednice"
  },
  "sharp_music_ab956814": {
    "message": "Ostro (glasba)"
  },
  "shift_arrows_4d5785fe": {
    "message": "Tipka SHIFT+puščične tipke"
  },
  "shift_o_to_open_the_pretty_html_editor_55ff5a31": {
    "message": "Urejevalnik Pretty HTML Editor odprete s pritiskom na tipki Shift+O"
  },
  "shortcut_911d6255": {
    "message": "Bližnjica"
  },
  "show_image_options_1e2ecc6b": {
    "message": "Prikaži možnosti slike"
  },
  "show_link_options_545338fd": {
    "message": "Prikaži povezave na slike"
  },
  "show_rolling_transcript_c1481744": {
    "message": "Prikaži tekoči prepis"
  },
  "show_rolling_transcript_d353aca4": {
    "message": "Prikaži tekoči prepis"
  },
  "sighted_users_browse_web_pages_quickly_looking_for_1d4db0c1": {
    "message": "Slabovidni uporabniki hitro brskajo po spletnih straneh in iščejo velike ali krepko zapisane naslove. Uporabniki bralnikov zaslonov se za razumevanje konteksta zanašajo na glave. Pri glavah mora biti uporabljena pravilna zgradba."
  },
  "sighted_users_browse_web_pages_quickly_looking_for_ade806f5": {
    "message": "Slabovidni uporabniki hitro brskajo po spletnih straneh in iščejo velike ali krepko zapisane naslove. Uporabniki bralnikov zaslonov se za razumevanje konteksta zanašajo na glave. Glave morajo biti jedrnate in imeti pravilno zgradbo."
  },
  "sigma_5c35e553": {
    "message": "Sigma"
  },
  "sigma_variant_8155625": {
    "message": "Sigma (različica)"
  },
  "single_color_image_4e5d4dbc": {
    "message": "Enobarvna slika"
  },
  "single_color_image_color_95fa9a87": {
    "message": "Enobarvna barva slike"
  },
  "size_b30e1077": {
    "message": "Velikost"
  },
  "size_of_caption_file_is_greater_than_the_maximum_m_bff5f86e": {
    "message": "Velikost je večja od največje dovoljene velikosti datoteke { max } kB."
  },
  "small_b070434a": {
    "message": "Majhna"
  },
  "small_width_x_height_px_359acd38": {
    "message": "Majhno ({ width } x { height }px)"
  },
  "solid_circle_9f061dfc": {
    "message": "Sklenjen krog"
  },
  "something_went_wrong_89195131": {
    "message": "Prišlo je do težav."
  },
  "something_went_wrong_accessing_your_webcam_6643b87e": {
    "message": "Pri dostopu do vaše spletne kamere je prišlo do težav."
  },
  "something_went_wrong_and_i_don_t_know_what_to_show_e0c54ec8": {
    "message": "Prišlo je do težav in ne vem, kaj vam naj prikažem."
  },
  "something_went_wrong_check_your_connection_reload__c7868286": {
    "message": "Prišlo je do težav. Preverite povezavo, osvežite stran in poskusite znova."
  },
  "something_went_wrong_d238c551": {
    "message": "Prišlo je do težav"
  },
  "something_went_wrong_while_sharing_your_screen_8de579e5": {
    "message": "Pri souporabi zaslon je prišlo je do težave."
  },
  "sort_by_e75f9e3e": {
    "message": "Razvrsti po"
  },
  "spades_suit_b37020c2": {
    "message": "Piki (obleka)"
  },
  "square_511eb3b3": {
    "message": "Kvadrat"
  },
  "square_cap_9ec88646": {
    "message": "Kvadratna kapica"
  },
  "square_cup_b0665113": {
    "message": "Kvadratna skodlica"
  },
  "square_root_e8bcbc60": {
    "message": "Kvadratni koren"
  },
  "square_root_symbol_d0898a53": {
    "message": "Simbol kvadratnega korena"
  },
  "square_subset_17be67cb": {
    "message": "Kvadratna podmnožica"
  },
  "square_subset_strict_7044e84f": {
    "message": "Kvadratna podmnožica (strogo)"
  },
  "square_superset_3be8dae1": {
    "message": "Kvadratna nadmnožica"
  },
  "square_superset_strict_fa4262e4": {
    "message": "Kvadratna nadmnožica (strogo)"
  },
  "square_unordered_list_b15ce93b": {
    "message": "nerazvrščeni seznam s kvadrati"
  },
  "star_8d156e09": {
    "message": "Zvezdica"
  },
  "start_over_f7552aa9": {
    "message": "Začnite znova"
  },
  "start_recording_9a65141a": {
    "message": "Zaženi snemanje"
  },
  "steel_blue_14296f08": {
    "message": "Kovinsko modra"
  },
  "studio_media_options_ee504361": {
    "message": "Prikaži medijske možnosti"
  },
  "studio_media_options_tray_cfb94654": {
    "message": "Prikaži pladenj z medijskimi možnostmi"
  },
  "styles_2aa721ef": {
    "message": "Slogi"
  },
  "submit_a3cc6859": {
    "message": "Pošlji"
  },
  "submitting_b90fac62": {
    "message": "Pošiljanje ..."
  },
  "subscript_59744f96": {
    "message": "Podpisano"
  },
  "subset_19c1a92f": {
    "message": "Podmnožica"
  },
  "subset_strict_8d8948d6": {
    "message": "Podmnožica (strogo)"
  },
  "succeeds_9cc31be9": {
    "message": "Naslednik"
  },
  "succeeds_equal_158e8c3a": {
    "message": "Naslednik enako"
  },
  "sum_b0842d31": {
    "message": "Vsota"
  },
  "superscript_8cb349a2": {
    "message": "Nadpisano"
  },
  "superscript_and_subscript_37f94a50": {
    "message": "Dvignjeno in spuščeno"
  },
  "superset_c4db8a7a": {
    "message": "Nadmnožica"
  },
  "superset_strict_c77dd6d2": {
    "message": "Nadmnožica (strogo)"
  },
  "supported_file_types_srt_or_webvtt_7d827ed": {
    "message": "Podprte vrste datotek: SRT ali WebVTT"
  },
  "switch_to_pretty_html_editor_a3cee15f": {
    "message": "Preklopi na urejevalnik Pretty HTML Editor"
  },
  "switch_to_raw_html_editor_f970ae1a": {
    "message": "Preklopi v surovi urejevalnik HTML"
  },
  "switch_to_the_html_editor_146dfffd": {
    "message": "Preklopi v urejevalnik html"
  },
  "switch_to_the_rich_text_editor_63c1ecf6": {
    "message": "Preklopi v urejevalnik obogatenega besedila"
  },
  "syllabus_f191f65b": {
    "message": "Učni načrt"
  },
  "system_audio_allowed_b2508f8c": {
    "message": "Zvok sistema omogočen"
  },
  "system_audio_disabled_c177bd13": {
    "message": "Zvok sistema onemogočen"
  },
  "tab_arrows_4cf5abfc": {
    "message": "ZAVIHEK/puščične tipke"
  },
  "table_header_starting_with_start_ffcabba6": {
    "message": "Glava preglednice, ki se začne s/z { start }"
  },
  "table_starting_with_start_e7232848": {
    "message": "Preglednica, ki se začne s/z { start }"
  },
  "tables_headers_should_specify_scope_5abf3a8e": {
    "message": "Pri glavah preglednic mora biti naveden obseg."
  },
  "tables_should_include_a_caption_describing_the_con_e91e78fc": {
    "message": "Preglednice morajo vsebovati spremno besedilo z opisom vsebine preglednice."
  },
  "tables_should_include_at_least_one_header_48779eac": {
    "message": "Preglednice morajo vključevati vsaj eno glavo."
  },
  "tau_880974b7": {
    "message": "Tau"
  },
  "teal_f729a294": {
    "message": "Zelenomodra"
  },
  "text_7f4593da": {
    "message": "Besedilo"
  },
  "text_background_color_16e61c3f": {
    "message": "Barva ozadja besedila"
  },
  "text_color_acf75eb6": {
    "message": "Barva besedila"
  },
  "text_is_difficult_to_read_without_sufficient_contr_69e62bd6": {
    "message": "Brez zadostnega kontrasta med besedilom in ozadjem je branje težavno, še posebej za slabovidne."
  },
  "text_larger_than_18pt_or_bold_14pt_should_display__5c364db6": {
    "message": "Pri besedilu, ki je večje od 18 pik (če je krepko, pa od 14 pik), mora biti kontrastno razmerje najmanj 3 : 1."
  },
  "text_optional_384f94f7": {
    "message": "Besedilo (neobvezno)"
  },
  "text_position_8df8c162": {
    "message": "Položaj besedila"
  },
  "text_size_887c2f6": {
    "message": "Velikost besedila"
  },
  "text_smaller_than_18pt_or_bold_14pt_should_display_aaffb22b": {
    "message": "Pri besedilu, ki je manjše od 18 pik (če je krepko, pa od 14 pik), mora biti kontrastno razmerje najmanj 4,5 : 1."
  },
  "the_document_preview_is_currently_being_processed__7d9ea135": {
    "message": "Predogled dokumenta je trenutno v obdelavi. Poskusite znova pozneje."
  },
  "the_first_heading_on_a_page_should_be_an_h2_859089f2": {
    "message": "Prvi naslov na strani mora biti H2."
  },
  "the_height_of_rich_content_area_is_decreased_36920e0": {
    "message": "Višina območja bogate vsebine se je zmanjšala."
  },
  "the_height_of_rich_content_area_is_increased_74c2358d": {
    "message": "Višina območja bogate vsebine se je povečala."
  },
  "the_material_is_in_the_public_domain_279c39a3": {
    "message": "Gradivo je dostopno javnosti."
  },
  "the_material_is_licensed_under_creative_commons_3242cb5e": {
    "message": "Gradivo je licencirano z licenco Creative Commons."
  },
  "the_material_is_subject_to_an_exception_e_g_fair_u_a39c8ca2": {
    "message": "Za gradivo velja izjema – npr. poštena uporaba, pravica do citiranja ali drugo v skladu z veljavno zakonodajo o avtorskih pravicah"
  },
  "the_pretty_html_editor_is_not_keyboard_accessible__d6d5d2b": {
    "message": "Urejevalnik Pretty HTML Editor ni dostopen s tipkovnico. Surovi urejevalnik HTML odprete s pritiskom na tipki Shift+O"
  },
  "therefore_d860e024": {
    "message": "Zato"
  },
  "theta_ce2d2350": {
    "message": "Teta"
  },
  "theta_variant_fff6da6f": {
    "message": "Teta (različica)"
  },
  "thick_downward_arrow_b85add4c": {
    "message": "Debela puščica navzdol"
  },
  "thick_left_arrow_d5f3e925": {
    "message": "Debela puščica levo"
  },
  "thick_leftward_arrow_6ab89880": {
    "message": "Debela puščica levo"
  },
  "thick_right_arrow_3ed5e8f7": {
    "message": "Debela puščica desno"
  },
  "thick_rightward_arrow_a2e1839e": {
    "message": "Debela puščica desno"
  },
  "thick_upward_arrow_acd20328": {
    "message": "Debela puščica navzgor"
  },
  "this_document_cannot_be_displayed_within_canvas_7aba77be": {
    "message": "Tega dokumenta v sistemu Canvas ni mogoče prikazati."
  },
  "this_equation_cannot_be_rendered_in_basic_view_9b6c07ae": {
    "message": "Te enačbe ni mogoče prikazati v osnovnem pogledu."
  },
  "this_image_is_currently_unavailable_25c68857": {
    "message": "Ta slika trenutno ni na voljo."
  },
  "this_video_may_display_youtube_ads_4d19d590": {
    "message": "V tem videoposnetku se lahko prikazujejo oglasi YouTube."
  },
  "though_your_video_will_have_the_correct_title_in_t_90e427f3": {
    "message": "Čeprav bo vaš videoposnetek v brskalniku imel pravilen naslov, ga v zbirki podatkov nismo uspeli posodobiti."
  },
  "thumbnail_e0de666f": {
    "message": "Sličica"
  },
  "timebar_a4d18443": {
    "message": "Časovna premica"
  },
  "title_can_t_be_blank_eb4021d7": {
    "message": "Naslov ne sme biti prazen"
  },
  "title_ee03d132": {
    "message": "Naslov"
  },
  "to_be_posted_when_d24bf7dc": {
    "message": "Za objavo: { when }"
  },
  "to_do_when_2783d78f": {
    "message": "Čakajoča opravila: { when }"
  },
  "toggle_summary_group_413df9ac": {
    "message": "Preklopi skupino { summary }"
  },
  "toggle_tooltip_d3b7cb86": {
    "message": "Preklop opisa orodja"
  },
  "tools_2fcf772e": {
    "message": "Orodja"
  },
  "top_66e0adb6": {
    "message": "Vrh"
  },
  "transcript_panel_is_available_at_widths_above_720p_1cf94c0d": {
    "message": "Panel s prepisi je na voljo pri širinah nad 720px."
  },
  "tray_839df38a": {
    "message": "Trak"
  },
  "triangle_6072304e": {
    "message": "Trikotnik"
  },
  "turnstile_yields_f9e76df1": {
    "message": "Vrtilni križ (odnos)"
  },
  "type_control_f9_to_access_image_options_text_a47e319f": {
    "message": "pritisnite Ctrl+F9 za dostop do možnosti slike. { text }"
  },
  "type_control_f9_to_access_link_options_text_4ead9682": {
    "message": "pritisnite Ctrl+F9 za dostop do možnosti povezave. { text }"
  },
  "type_control_f9_to_access_table_options_text_92141329": {
    "message": "pritisnite Ctrl+F9 za dostop do možnosti preglednice. { text }"
  },
  "unable_to_determine_resource_selection_url_7867e060": {
    "message": "Ni mogoče določiti URL za izbiro vira"
  },
  "underline_applied_ae01ec97": {
    "message": "Podčrtana pisava uporabljena"
  },
  "underline_removed_3693e17c": {
    "message": "Podčrtana pisava odstranjena"
  },
  "union_e6b57a53": {
    "message": "Unija"
  },
  "unpublished_dfd8801": {
    "message": "neobjavljeno"
  },
  "unsaved_changes_will_be_lost_f977252a": {
    "message": "Neshranjene spremembe bodo izgubljene."
  },
  "untitled_16aa4f2b": {
    "message": "Brez naslova"
  },
  "untitled_efdc2d7d": {
    "message": "brez naslova"
  },
  "up_and_left_diagonal_arrow_e4a74a23": {
    "message": "Diagonalna puščica navzdol in levo"
  },
  "up_and_right_diagonal_arrow_935b902e": {
    "message": "Diagonalna puščica navzdol in desno"
  },
  "up_c553575d": {
    "message": "Navzgor"
  },
  "updated_link_a827e441": {
    "message": "Posodobljena povezava"
  },
  "upload_document_253f0478": {
    "message": "Naloži dokument"
  },
  "upload_file_fd2361b8": {
    "message": "Naloži datoteko"
  },
  "upload_image_6120b609": {
    "message": "Naloži sliko"
  },
  "upload_media_ce31135a": {
    "message": "Naloži medije"
  },
  "upload_record_media_e4207d72": {
    "message": "Naloži/posnemi medij"
  },
  "uploading_19e8a4e7": {
    "message": "Nalaganje"
  },
  "uppercase_alphabetic_ordered_list_3f5aa6b2": {
    "message": "abecedno urejeni seznam z velikimi začetnicami"
  },
  "uppercase_delta_d4f4bc41": {
    "message": "Velika delta"
  },
  "uppercase_gamma_86f492e9": {
    "message": "Velika gama"
  },
  "uppercase_lambda_c78d8ed4": {
    "message": "Velika lambda"
  },
  "uppercase_omega_8aedfa2": {
    "message": "Velika omega"
  },
  "uppercase_phi_caa36724": {
    "message": "Velika fi"
  },
  "uppercase_pi_fcc70f5e": {
    "message": "Velika pi"
  },
  "uppercase_psi_6395acbe": {
    "message": "Velika psi"
  },
  "uppercase_roman_numeral_ordered_list_853f292b": {
    "message": "abecedno urejeni seznam z rimskimi številkami"
  },
  "uppercase_sigma_dbb70e92": {
    "message": "Velika sigma"
  },
  "uppercase_theta_49afc891": {
    "message": "Velika teta"
  },
  "uppercase_upsilon_8c1e623e": {
    "message": "Velika ipsilon"
  },
  "uppercase_xi_341e8556": {
    "message": "Velika ksi"
  },
  "upsilon_33651634": {
    "message": "Ipsilon"
  },
  "upward_and_downward_pointing_arrow_fa90a918": {
    "message": "Navzgor in navzdol usmerjena puščica"
  },
  "upward_and_downward_pointing_arrow_thick_d420fdef": {
    "message": "Navzgor in navzdol usmerjena puščica (debela)"
  },
  "upward_arrow_9992cb2d": {
    "message": "Navzgor usmerjena puščica"
  },
  "upward_pointing_triangle_d078d7cb": {
    "message": "Navzgor usmerjeni trikotnik"
  },
  "url_22a5f3b8": {
    "message": "URL"
  },
  "usage_right_ff96f3e2": {
    "message": "Pravica uporabe:"
  },
  "usage_rights_required_5fe4dd68": {
    "message": "Pravice uporabe (obvezno)"
  },
  "use_arrow_keys_to_navigate_options_2021cc50": {
    "message": "Po možnostih se premikajte s puščičnima tipkama."
  },
  "use_arrow_keys_to_select_a_shape_c8eb57ed": {
    "message": "Za izbiro oblike uporabite puščične tipke."
  },
  "use_arrow_keys_to_select_a_size_699a19f4": {
    "message": "Za izbiro velikosti uporabite puščične tipke."
  },
  "use_arrow_keys_to_select_a_text_position_72f9137c": {
    "message": "Za izbiro položaja besedila uporabite puščične tipke."
  },
  "use_arrow_keys_to_select_a_text_size_65e89336": {
    "message": "Za izbiro velikosti besedila uporabite puščične tipke."
  },
  "use_arrow_keys_to_select_an_outline_size_e009d6b0": {
    "message": "Za izbiro velikosti orisa uporabite puščične tipke."
  },
  "used_by_screen_readers_to_describe_the_content_of__4f14b4e4": {
    "message": "Uporabljajo ga bralniki zaslona za opisovanje vsebine { TYPE }"
  },
  "used_by_screen_readers_to_describe_the_content_of__b1e76d9e": {
    "message": "Uporabljajo ga bralniki zaslona za opisovanje vsebine slike"
  },
  "user_documents_c206e61f": {
    "message": "Uporabniški dokumenti"
  },
  "user_files_78e21703": {
    "message": "Uporabniške datoteke"
  },
  "user_images_b6490852": {
    "message": "Uporabniške slike"
  },
  "user_media_14fbf656": {
    "message": "Uporabnikovi mediji"
  },
  "vector_notation_cf6086ab": {
    "message": "Vektor (oznaka)"
  },
  "vertical_bar_set_builder_notation_4300495f": {
    "message": "Navpična vrstica (Set Builder Notation)"
  },
  "vertical_dots_bfb21f14": {
    "message": "Navpične pike"
  },
  "video_options_24ef6e5d": {
    "message": "Možnosti videoposnetka"
  },
  "video_options_tray_3b9809a5": {
    "message": "Vrstica z možnostmi videoposnetka"
  },
  "video_player_b371005": {
    "message": "Predvajalnik videoposnetkov"
  },
  "video_player_for_9e7d373b": {
    "message": "Predvajalnik videoposnetkov za "
  },
  "video_player_for_title_ffd9fbc4": {
    "message": "Predvajalnik videoposnetkov za { title }"
  },
  "video_url_889d3263": {
    "message": "URL videoposnetka"
  },
  "view_all_e13bf0a6": {
    "message": "Prikaži vse"
  },
  "view_ba339f93": {
    "message": "Ogled"
  },
  "view_description_30446afc": {
    "message": "Prikaz opisa"
  },
  "view_keyboard_shortcuts_34d1be0b": {
    "message": "Prikaži bližnjice na tipkovnici"
  },
  "view_title_description_67940918": {
    "message": "Prikaz opisa { title }"
  },
  "view_word_and_character_counts_a743dd0c": {
    "message": "Prikaži štetje besed in znakov"
  },
  "viewer_restrictions_e14274c9": {
    "message": "Omejitve ogledovalcev"
  },
  "we_couldn_t_detect_a_working_microphone_connected__ceb71c40": {
    "message": "Delujočega mikrofona, priključenega na napravo, ni bilo mogoče zaznati."
  },
  "we_couldn_t_detect_a_working_webcam_connected_to_y_6715cc4": {
    "message": "Delujoče spletne kamere, priključene na napravo, ni bilo mogoče zaznati."
  },
  "we_couldn_t_detect_a_working_webcam_or_microphone__263b6674": {
    "message": "Delujoče spletne kamere ali mikrofona, priključenih na napravo, ni bilo mogoče zaznati."
  },
  "webcam_disabled_30c66986": {
    "message": "Spletna kamera onemogočena"
  },
  "webcam_fe91b20f": {
    "message": "Spletna kamera"
  },
  "webpages_should_only_have_a_single_h1_which_is_aut_dc99189e": {
    "message": "Spletne strani morajo imeti samo en H1, ki se samodejno uporabi za naslov strani. Prvi naslov v vaši vsebini mora biti H2."
  },
  "when_markup_is_used_that_visually_formats_items_as_f941fc1b": {
    "message": "Če je uporabljeno označevanje, ki vizualno oblikuje elemente kot seznam, ne kaže pa razmerja seznama, imajo lahko uporabniki težave pri navigiranju po informacijah."
  },
  "white_87fa64fd": {
    "message": "Belo"
  },
  "why_523b3d8c": {
    "message": "Zakaj"
  },
  "width_492fec76": {
    "message": "Širina"
  },
  "width_and_height_must_be_numbers_110ab2e3": {
    "message": "Širina in višina morata biti številki"
  },
  "width_x_height_px_ff3ccb93": {
    "message": "{ width } x { height } px"
  },
  "wiki_home_9cd54d0": {
    "message": "Glavna stran wiki"
  },
  "word_count_c77fe3a6": {
    "message": "Štetje besed"
  },
  "words_b448b7d5": {
    "message": "Besede"
  },
  "wreath_product_200b38ef": {
    "message": "Venčni produkt"
  },
  "xi_149681d0": {
    "message": "Ksi"
  },
  "yes_dde87d5": {
    "message": "Da"
  },
  "you_are_on_a_color_palette_to_navigate_on_the_pale_227fc3a6": {
    "message": "Ste na barvni paleti. Za krmarjenje po paleti gor, levo, dol ali desno uporabite tipke W, A, S oziroma D."
  },
  "you_are_on_a_color_slider_to_navigate_the_slider_l_e800f68a": {
    "message": "Ste na barvnem drsniku. Za krmarjenje po drsniku levo ali desno uporabite tipko A oziroma D."
  },
  "you_are_on_an_alpha_slider_to_navigate_the_slider__3a014dc5": {
    "message": "Ste na drsniku alfa. Za krmarjenje po drsniku levo ali desno uporabite tipko A oziroma D."
  },
  "you_have_unsaved_changes_in_the_icon_maker_tray_do_e8cf5f1b": {
    "message": "V pladnju ustvarjalnika ikon imate neshranjene spremembe. Ali želite nadaljevati brez shranjevanja teh sprememb?"
  },
  "you_may_need_to_adjust_additional_headings_to_main_975f0eee": {
    "message": "Morda boste morali prilagoditi dodatne naslove, da ohranite hierarhijo strani."
  },
  "you_may_not_upload_an_empty_file_11c31eb2": {
    "message": "Prazne datoteke ne smete naložiti."
  },
  "your_image_has_been_compressed_for_icon_maker_imag_2e45cd91": {
    "message": "Vaša slika je bila stisnjena za Icon Maker. Slike, manjše od { size } KB ne bodo stisnjene."
  },
  "your_microphone_is_blocked_in_the_browser_settings_42af0ddc": {
    "message": "Vaš mikrofon je blokiran v nastavitvah brskalnika."
  },
  "your_webcam_and_microphone_are_blocked_in_the_brow_73357dc6": {
    "message": "Vaša spletna kamera in mikrofon sta blokirana v nastavitvah brskalnika."
  },
  "your_webcam_is_blocked_in_the_browser_settings_7f638128": {
    "message": "Vaša spletna kamera je blokirana v nastavitvah brskalnika."
  },
  "your_webcam_may_already_be_in_use_6cd64c25": {
    "message": "Vaša spletna kamera je morda že v uporabi."
  },
  "youtube_embed_url_5c1018d4": {
    "message": "URL za vdelavo YouTube"
  },
  "zeta_5ef24f0e": {
    "message": "Zeta"
  },
  "zoom_f3e54d69": {
    "message": "Povečava"
  },
  "zoom_in_image_bb97d4f": {
    "message": "Povečaj sliko"
  },
  "zoom_out_image_d0a0a2ec": {
    "message": "Pomanjšaj sliko"
  }
};
formatMessage.addLocale({
  sl: locale
});